import React from 'react';

const initialValues = {
  isReady: false,
  coachTracks: [],
  showArchivedCoachTracks: false,
  coachTracksCollection: {},
  publicTracksCollection: {},
  equipmentList: [],
};

const ManageTrackContext = React.createContext(initialValues);

export default ManageTrackContext;
export {
  initialValues,
};
